import isNil from 'lodash/isNil';

/**
 * - prod = Production
 * - dev  = Development
 * - ci   = Integration Testing (i.e. cypress)
 * - test = Unit Testing (i.e. vitest)
 */
export type PortalEnvironment = 'prod' | 'dev' | 'ci' | 'test';

/**
 * Gets the current `PortalEnvironment`
 */
export const getPortalEnvironment = (): PortalEnvironment => {
    if (isNil(process.env.NODE_ENV)) {
        throw new Error('getPortalEnvironment() cannot be called from browser!');
    }
    if (process.env.IN_CI === 'true') {
        return 'ci';
    }
    if (process.env.NODE_ENV === 'production') {
        return 'prod';
    }
    if (process.env.NODE_ENV === 'test') {
        return 'test';
    }
    return 'dev';
};

/**
 * Checks if the current `PortalEnvironment` is one of the options in the arg
 */
export const isPortalEnvironment = (envs: PortalEnvironment[]) => envs.includes(getPortalEnvironment());
